import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper, getObjectValue } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " header-style-override ";
},"3":function(container,depth0,helpers,partials,data) {
    return "<div class=\"section-banner-image\"></div>";
},"5":function(container,depth0,helpers,partials,data) {
    return "negative-margins";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),"headerPartialName",{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":23,"column":15},"end":{"line":23,"column":50}}}),depth0,{"data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerRemoved") : stack1),{"name":"unless","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":29,"column":23}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <h2 class=\"campaign-properties-section heading show-for-medium-up"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"title-position") : stack1),"==","center",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":79},"end":{"line":26,"column":151}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"title-position") : stack1),"==","right",{"name":"compare","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":151},"end":{"line":26,"column":221}}})) != null ? stack1 : "")
    + "\">\r\n              </h2>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    return " text-center";
},"13":function(container,depth0,helpers,partials,data) {
    return " text-right";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"row small-collapse"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerStyleOverride") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":30},"end":{"line":2,"column":114}}})) != null ? stack1 : "")
    + "\">\r\n  <div class=\"column small-12\">\r\n    <section class=\"squeezebox-wrapper\" id=\"sbox-wrap-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1),"==","rewardsCollapsibleSection",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":5,"column":122}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"squeezebox-panels\">\r\n        <div\r\n          id=\"sbox-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\"\r\n          class=\"squeezebox-panel active "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"negativeColumnMargins") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":41},"end":{"line":20,"column":100}}})) != null ? stack1 : "")
    + "\"\r\n        >\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerPartialName") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":22,"column":10},"end":{"line":30,"column":17}}})) != null ? stack1 : "")
    + "          <a\r\n            href=\"javascript:void(0);\"\r\n            class=\"panel-header spa-oline hide-for-medium-up\"\r\n            data-panel=\"sbox-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\"\r\n            id=\"sbox-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\"\r\n          >\r\n            <span class=\"spa-squeezebox-arrow spa-icon icon-chevron-up\"></span>\r\n            <h2 class=\"campaign-properties-section heading show-for-small-only\">\r\n            </h2>\r\n          </a>\r\n\r\n          <div class=\"panel-content transparent-background\" aria-labelledby=\"collSectionTab1\">\r\n            <div class=\"content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"children") : depth0),{"name":"each","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":14},"end":{"line":47,"column":23}}})) != null ? stack1 : "")
    + "            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"collapsible-section-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":56,"column":48},"end":{"line":56,"column":62}}}))
    + "\"></div>\r\n";
},"usePartial":true,"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = (lookupProperty(helpers,"getObjectValue")||(depth0 && lookupProperty(depth0,"getObjectValue"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"titles") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1),{"name":"getObjectValue","hash":{},"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":3,"column":56}}})) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/collapsible-section-cc-module",
  "version": "5.0.0",
  "id": "collapsibleSectionCCodule",
  "containerID": "creditCardsCollapsibleSectionCcModule",
  "moduleName": "credit-cards-collapsible-section-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "collapsible-section-cc-module",
  "data": {
    "init": "collapsibleSectionCCModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "headerPartialName",
    "type": "string",
    "default": "",
    "description": "Partial name to load instead of default header"
  }, {
    "name": "headerRemoved",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Removed the header added by this module and let the child module set its own header for medium up"
  }, {
    "name": "headerStyleOverride",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Use boolean value to latch onto with handlebars logic to add a class to the parent container that would style the components header differently when needed"
  }, {
    "name": "lastCollapsibleSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Added to initialize the accordion utility after all sections have loaded."
  }, {
    "name": "negativeColumnMargins",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Add negative left/right 10px margins."
  }, {
    "name": "title-position",
    "type": "string",
    "values": ["left", "center", "right"],
    "default": "left",
    "description": "Positions the title in the middle, left, or right"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        compare,
        json,
        htmlEscaper,
        getObjectValue
      },
      "partials": {
        "collapsible-section-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "collapsible-section-cc-partial": renderTemplate
  },
  "helpers": {
    compare,
    json,
    htmlEscaper,
    getObjectValue
  },
  "dependencies": {
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class collapsibleSectionCCModuleJS
 * @extends {Module}
 */
class collapsibleSectionCCModuleJS extends Module {
  /**
   * Creates an instance of collapsibleSectionCCModuleJS.
   * @param {*} options - options object
   * @param {*} context - context object
   * @memberof collapsibleSectionCCModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.target = this.settings.target;
    this.content = JSON.parse(this.target.querySelector('#collapsible-section-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['collapsible-section-cc-partial'];
  }

  /**
   * Initialize the module by subbing to the campaignProperties
   * loaded event, and rendering the page using that data.
   *
   * @memberof collapsibleSectionCCModuleJS
   * @returns {void}
   */
  init() {
    spartaEventsUtility.sub('campaignProperties-spartaStore', data => {
      const campaignProperties = data.data.data;
      const campaign = spartaStoreUtility.getData('campaign');
      const containerID = `${this.target.id}`;
      const module = {
        ...this.params,
        containerID
      };
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        site: spaParams.siteParams,
        module,
        content: linkContent
      });
      const campaignPropertiesSections = this.target.querySelectorAll('.campaign-properties-section');
      [...campaignPropertiesSections].forEach(section => {
        // eslint-disable-next-line no-param-reassign
        section.innerHTML = renderedTemplate;
      });
      spartaSqueezeboxUtility.init();

      // Open/close panel based on media queries.
      spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, e => {
        const panelWrapper = this.settings.target.querySelector(`#sbox-wrap-${this.settings.target.id}`);

        // If the panel is closed and the viewport is not small
        if (Array.from(panelWrapper.classList).indexOf('all-panels-closed') >= 0 && e.data.viewport.indexOf('small') < 0) {
          spartaSqueezeboxUtility.exposeAllPanels(panelWrapper);
        }
      }, true);
    });
  }
}
registerModuleClass({
  moduleClass: collapsibleSectionCCModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { collapsibleSectionCCModuleJS as default, moduleConfig };
